/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobResponse {
    getFixupPrototypeFunction() { return PolicyJobResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobResponse>): PolicyJobResponse {
        let obj = Object.assign(new PolicyJobResponse(), model);
        PolicyJobResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobResponse>): PolicyJobResponse {
        if (!model) return null;
        return PolicyJobResponse.newInstance(<PolicyJobResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobResponse) {
        if (!obj) return;

        models.PolicyJobResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobResponse): boolean {
        Object.setPrototypeOf(obj, PolicyJobResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.evaluated_resources_count === undefined) {
            this.evaluated_resources_count = 0;
        }
        if (this.violated_resources_count === undefined) {
            this.violated_resources_count = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
        if (this.violated_resources) {
            for (let val of this.violated_resources) {
                models.JobExecutionOutputDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Job ID
     */
    id: string;

    /**
     * Job name
     */
    name: string;

    /**
     * Status of policy job execution
     */
    status: models.PolicyJobStatus;

    /**
     * Reason for job failure.
     */
    failure_reason: string;

    /**
     * Whether this policy job has been archived and is excluded from the default (non-archived) job list
     */
    archived: boolean;

    /**
     * Engine type of the policy
     */
    engine: models.PolicyEngineType;

    /**
     * Execution type of policy job
     */
    execution_type: models.PolicyJobExecutionType;

    /**
     * Execution group of policy job
     */
    execution_group: models.PolicyJobExecutionGroup;

    /**
     * Policy execution reference ID
     */
    execution_reference: string;

    /**
     * Arguments used for job execution
     */
    args: any;

    /**
     * Policy ID
     */
    policy_id: string;

    /**
     * Number of evaluated resources
     */
    evaluated_resources_count: number;

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * Resources that violated the policy
     */
    violated_resources: Array<models.JobExecutionOutputDetails>;

    /**
     * Total number of resources that violated the policy
     */
    violated_resources_count: number;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Job created time in UTC
     */
    created_at: Date;

    /**
     * Job updated time in UTC
     */
    updated_at: Date;

    /**
     * Created by
     */
    created_by: string;

    /**
     * Updated by
     */
    updated_by: string;

    /**
     * Pagination cursor for next page of violated_resources
     */
    next_list_context: models.ListContext;

    /**
     * Notification configuration that was used for this execution, if any
     */
    notifications: models.ConfigurationForNotifications;

}
